import moment from "moment";

function dateSort(event, data, fieldName) {
    const compareFunction = function (a, b) {
        const momentA = moment(a[fieldName], "DD/MM/YYYY HH:mm");
        const momentB = moment(b[fieldName], "DD/MM/YYYY HH:mm");
        const result = momentB.isBefore(momentA) ? 1 : -1;

        return result * event.order;
    };

    data.sort(compareFunction);
    return data;
}

export function generateCustomSortAttributes(customSort, data) {
    if(!customSort) {
        return {};
    }

    if(customSort.type === "date") {
        return {sortFunction: (event) => dateSort(event, data, customSort.field)}
    }
    else {
        return {}
    }
}



export function customFormat({ field, rowData, column, customColumn }) {
  const { format, formatOptions } = field;

  switch (format) {
    case "boolean":
      return formatBoolean(rowData, column, formatOptions?.valueforYes);

    case "camelAsTitleCase":
      return formatCamelAsTitleCase(rowData, column);

    case "timestampForHumans":
      return moment(rowData[column.field]).format("DD/MM/YYYY HH:mm");

    case "jsx":
      const customComponent = customColumn(column.field, rowData);
      if (formatOptions?.requireRowData) {
        return {...customComponent, props: { ...customComponent.props, rowData, column } };
      }
      return customComponent;
    
    case "truncateString":
      return truncateString(rowData[column.field]);

    default:
      return `TODO - implement format: ${format}`;
  }
}

function formatBoolean(rowData, column, valueforYes) {
  if(valueforYes){
    return rowData[column.field] === valueforYes ? "Yes" : "No"
  }
  return rowData[column.field] ? "Yes" : "No";
}

function formatCamelAsTitleCase(rowData, column) {
    return rowData[column.field].replace(/([A-Z])/g, (match) => ` ${match}`)
        .replace(/^./, (match) => match.toUpperCase())
        .trim();
}

function truncateString(str){
  return(
    <div className="truncate" style={{maxWidth: "10rem"}}>
      {str}
    </div>
  )
}
